import { AppBar, AppBarContent, ButtonLink, RiCloseLine, Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { usePreviousPath } from '../hooks/usePreviousPath';

export type TitleBarProps = {
  title: string;
};

export const TitleBar = ({ title }: TitleBarProps) => {
  const { t } = useTranslation();
  const backPath = usePreviousPath();

  return (
    <AppBar data-testid='titlebar'>
      <AppBarContent>
        <Stack className='min-w-0 gap-1'>
          <span className='typography-h4'>{title}</span>
        </Stack>
        <ButtonLink
          to={backPath}
          variant='text'
          rightAdornment={<RiCloseLine size={24} className='text-text-secondary' />}
        >
          {t('global.ui.buttons.cancel')}
        </ButtonLink>
      </AppBarContent>
    </AppBar>
  );
};
